import React, {lazy, Suspense} from 'react'

const DefinitionSinglePageLazy = lazy(() =>
    import('./DefinitionSinglePage')
)

const DefinitionSinglePage = props => (
    <Suspense fallback={null}>
        <DefinitionSinglePageLazy {...props} />
    </Suspense>
)

export default DefinitionSinglePage
